import $ from 'jquery';
import { track } from './tracking';

$(function() {
    var hutk = document.cookie.replace(/(?:(?:^|.*;\s*)hubspotutk\s*\=\s*([^;]*).*$)|^.*$/, "$1");
    if (hutk) {
        var $elem = $("input[name='hutk']");
        if ($elem) {
            $elem.val(hutk);
        }
    }

    window.addEventListener("message", function(event) {
        if (event.data.type === 'hsFormCallback' && event.data.eventName === 'onFormSubmitted') {
            track('hubspot-form', 'hubspot-form-success', event.data.id);
        }
    });
});